<template>
  <v-btn
    class="os-rounded"
    :type="type"
    :block="block"
    :elevation="elevation"
    :color="color"
    :loading="loading"
    :disabled="disabled"
    :dark="loading ? false : dark"
    v-on="$listeners"
  >
    <!-- @click="$emit('click', $event)" -->
    <slot></slot>
  </v-btn>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    type: {
      type: String,
      default: 'button'
    },
    block: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: [String, Number],
      default: 0
    },
    color: {
      type: String,
      default: 'primary'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
})
export default class Button extends Vue {
  data () {
    return {
      btnPrimaryConfig: {
        color: 'primary',
        dark: true
      }
    }
  }
}
</script>
